module.exports = __webpack_public_path__ + "img/helene_s.91813a33.png";